// tutorial: traduzioni delle stringhe della funzione di traduzione $t
// traduzione dei messaggi d'errore di vee-validate
const fr = {
    'countryCode': 'fr_fr',
    'Accetto il regolamento fidelity e la privacy policy': 'J\'accepte le règlement fidelity et la politique de confidentialité',
    'Account creation': 'Création de compte',
    'Add address': 'Ajouter adresse',
    'Address': 'Adresse',
    'Address label': 'Nom adresse',
    'Address label placeholder': 'par exemple : domicile, travail...',
    'Amount': 'Montant',
    'Apply': 'Appliquer',
    'Apply Discount': 'Appliquer la remise',
    'Are you sure you want to delete this item from cart': 'Êtes-vous sûr de vouloir supprimer cet article du panier ?',
    'Are you sure you want to move this item to wishlist?': 'Êtes-vous sûr de vouloir déplacer cet article vers la liste de souhaits ?',
    'articles': 'articles',
    'articles inside': 'objets présents',
    'Back': 'Précédent',
    'Back to cart': 'Retour au panier',
    'Back to shopping': 'Continuer les achats',
    'Back to store': 'Retour au magasin',
    'Billing address': 'Adresse de facturation',
    'Billing address is the same as the shipping address': 'Les données de facturation et d\'expédition sont identiques',
    'Buy': 'Acheter',
    'Buy Now': 'Acheter maintenant',
    'Buy now, pay later': 'Achetez maintenant, payez plus tard',
    'Cancel': 'Annuler',
    'Cannot apply Gift Card': 'Impossible d\'utiliser la carte cadeau',
    'Cannot apply glam card points': 'Impossible d\'appliquer les points de votre WE Card',
    'Card issuer authentication failed': 'L’authentification du porteur de la carte n’a pas réussi',
    'Cart': 'Panier',
    'Cart content': 'Contenu du panier',
    'Change': 'Changement',
    'Change address': 'Modifier l\'adresse',
    'Change e-mail': 'Modifier l\'e- mail',
    'Change pickup point': 'Changer de point de retrait',
    'Check zip code': 'Vérifiez le code postal',
    'Choose a shipping method in order to proceed': 'Pour poursuivre, sélectionnez le mode d\'expédition',
    'Choose a store for the pick-up in order to proceed': 'Pour continuer, choisissez le magasin où vous souhaitez récupérer votre commande.',
    'Choose a zipcode in order to proceed': 'Pour continuer, entrez un code postal.',
    'City': 'Ville',
    'Close': 'Clôturer',
    'Closed': 'Fermé',
    'Color': 'Couleur',
    'Complete your order': 'Finaliser la commande',
    'Condizioni di vendita': 'Conditions de vente',
    'Confirm': 'Confirmer',
    'Continue': 'Suivant',
    'Continue as guest': 'Continuer comme invité',
    'Country': 'Pays',
    'Coupon': 'Coupon',
    'Coupon Code': 'Code remise',
    'Credit Card': 'Carte de crédit',
    'Credit Card Number': 'Numéro de la carte',
    'data': 'données',
    'Date of birth': 'Date de naissance',
    'Date of Birth': 'Date de naissance',
    'dd/mm/yyyy': 'jj/mm/aaaa',
    'Delete': 'Effacer',
    'Delivery:': 'Livraison :',
    'Description': 'Description',
    'Do you have a discount code?': 'Avez-vous un code de réduction ?',
    'Enter your Gift Card here': 'Saisissez votre carte cadeau ici',
    'do-login': 'Connectez-vous',
    'done': 'fini',
    'E-mail address': 'E-mail',
    'Edit': 'Modifier',
    'Edit address': 'Modifier l\'adresse',
    'Edit Cart': 'Modifier le panier',
    'Email': 'E-mail',
    'Email and telephone number': 'E-mail et numéro de téléphone',
    'email-remainder': 'Nous vous avons envoyé un e-mail pour réinitialiser votre mot de passe. Cliquez sur le lien qu\'il contient.',
    'Empty credit card fields': 'Veuillez saisir les données de la carte de crédit',
    'Enter shipping address': 'Entrez l\'adresse de livraison',
    'Enter the points to be used here': 'Enter the points to be used here',
    'Error during payment authorization': 'Erreur pendant l’autorisation de paiement',
    'Error during registration': 'Erreur pendant l\'enregistrement',
    'Error occurred while placing orde': 'Une erreur est survenue pendant votre commande',
    'Expire Date': 'Expiration',
    'Female': 'Femme',
    'Firstname': 'Prénom',
    'Forgot your password?': 'Mot de passe oublié ?',
    'Free': 'Gratuit',
    'Friday': 'vendredi',
    'From': 'De',
    'Gender': 'Sexe',
    'Gift Card': 'Cartes-cadeaux',
    'Gift card and discount codes': 'Cartes-cadeaux et codes de réduction',
    'giftcardmsg': 'Giftcard {code}',
    'Glam card discount': 'Remise points WE Card',
    'glamcard-bonusapplied': '{Bonus} points de votre WE Card appliqués',
    'Go to checkout': 'Passer à la caisse',
    'Go to payment': 'Accéder au paiement',
    'Go to shipping': 'Aller à l\'expédition',
    'Go to summary': 'Aller au résumé',
    'Home delivery cost': 'Frais de livraison à domicile',
    'How many points do you want to use?': 'Combien de bonus souhaitez-vous utiliser ?',
    'How much bonus do you want to use?': 'Combien de points souhaitez-vous utiliser ?',
    'I don\'t want to receive the invoice': 'Je ne souhaite pas recevoir la facture',
    'I want to receive the invoice': 'Je souhaite recevoir une facture',
    'Identical to shipping address': 'Identique à l\'adresse d\'expédition',
    'Insert here coupon code': 'Saisissez ici le code de remise',
    'Insert here the shipping data': 'Saisissez ici les données d\'expédition',
    'Insert here your email to proceed, we will send you just the order updates': 'Saisissez votre e-mail pour continuer, nous ne vous enverrons que des informations concernant votre commande',
    'Insert your billing address': 'Saisissez votre adresse de facturation',
    'invoice': 'paiement',
    'Invoice address': 'Adresse de facturation',
    'Last name': 'Nom',
    'Lastname': 'Nom',
    'Leave': 'Quitter',
    'Loading': 'Chargement en cours',
    'Loading payment form, please wait': 'Chargement du formulaire de paiement en cours, veuillez patienter',
    'login': 'Connexion',
    'Login': 'Connexion',
    'Male': 'Homme',
    'Message': 'Message',
    'Mobile phone': 'Numéro de téléphone',
    'Monday': 'lundi',
    'Move item': 'Déplacer l\'article',
    'Move product': 'Déplacer le produit',
    'Name': 'Prénom',
    'New address': 'Nouvelle adresse',
    'New client': 'Nouveau client',
    'No items in cart': 'Le panier est vide',
    'No near stores': 'Pas de magasins à proximité',
    'No shipping methods available': 'Aucune méthode d\'expédition disponible',
    'Not registered yet?': 'Vous n\'êtes pas encore enregistré ? ',
    'Ok': 'Ok',
    'Or': 'Ou',
    'Order detail': 'Détails de la commande',
    'Order details': 'Détails de la commande',
    'Order placed': 'Commande passée. Vous allez être redirigé vers la page de récapitulatif',
    'Order will be shipped to': 'La commande sera expédiée à',
    'Password': 'Mot de passe',
    'Password confirm': 'Confirmer le mot de passe',
    'Pay': 'Payer',
    'payment': 'Paiement',
    'Payment': 'Paiement',
    'Payment error.': 'Erreur de paiement.',
    'Payment method': 'Méthode de paiement',
    'Payment method not supported': 'Méthode de paiement non acceptée',
    'Personal data': 'Données personnelles',
    'Place of birth': 'Lieu de naissance',
    'Place of Birth': 'Lieu de naissance',
    'Please select shipping from Amazon widget': 'Choisissez la livraison sur Amazon Widget',
    'Please try again with another form of payment': 'Essayez à nouveau avec une autre forme de paiement',
    'Please wait': 'Attendre svp',
    'Please wait, payment is processing': 'Paiement en cours, veuillez patienter',
    'Prefix': 'Préfixe',
    'Postcode': 'C.P.',
    'Proceed': 'Poursuivre',
    'Proceed delete': 'Continuer',
    'Proceed to payment': 'Procéder au paiement',
    'Proceed with the purchase': 'Procéder à l\'achat',
    'product': 'produit',
    'Product': 'Produit',
    'products': 'produits',
    'Products total': 'Total produits',
    'Quantity': 'Quantité',
    'Register': 'Créer un compte',
    'Registered User': 'Utilisateur enregistré',
    'Registration agreement': 'Règlement inscription',
    'Registration successful': 'Inscription réussie',
    'registrationagreement': 'J\'accepte le < a href = "{linkfid}" target = "_blank" > règlement fidelity < /a> et la <a href="{linkpriv}" target="_blank">politique de confidentialité</a > ',
    'Remove': 'Supprimer',
    'Remove Discount': 'Supprimer la remise',
    'Remove the item': 'Retirer article',
    'Required fields': 'Champs obligatoires',
    'Retry': 'Veuillez réessayer',
    'review': 'récapitulatif',
    'Safe purchase': 'Achat sûr',
    'Same as billing': 'Identique à l\'adresse de facturation',
    'Saturday': 'samedi',
    'Save': 'Sauvegarder',
    'Save address': 'Enregistrer l\'adresse',
    'Save in address book': 'Enregistrer dans le répertoire',
    'Save new address to proceed': 'Enregistrer la nouvelle adresse pour continuer',
    'Select': 'Sélectionner',
    'Select a city': 'Sélectionner la ville',
    'Select a payment method': 'Sélectionner une méthode de paiement',
    'Select a region': 'Sélectionner la région',
    'Select an address': 'Choisissez une adresse',
    'Select here your shipping address': 'Sélectionnez ici votre adresse d\'expédition',
    'Select payment method': 'Sélectionner une méthode de paiement',
    'Select region': 'Sélectionner la province',
    'Select shipping method': 'Sélectionner une méthode d\'expédition',
    'Select store pickup': 'Sélectionnez le retrait en magasin',
    'Select store pickup to procede': 'Pour continuer, choisissez un magasin',
    'Select the store': 'Sélectionner le magasin',
    'Select this store': 'Sélectionner ce magasin',
    'Select value': 'Sélectionner une valeur',
    'Selected Store': 'Magasin sélectionné',
    'Seleziona il metodo di spedizione': 'Sélectionner la méthode d\'expédition',
    'Send remainder': 'Envoyer un e-mail de récupération du mot de passe',
    'Service unavailable, retry later': 'Erreur temporaire pendant la demande, réessayez dans quelques instants',
    'Session expired, page will reload': 'La session a expiré, la page va être actualisée',
    'shipping': 'Expédition',
    'Shipping': 'Expédition',
    'Shipping address': 'Adresse d\'expédition',
    'Shipping and handling': 'Expédition et gestion',
    'Shipping data': 'Données d\'expédition',
    'Shipping informations': 'Informations d\'expédition',
    'Shop opening hours': 'Heures d\'ouverture du magasin',
    'Shopping Cart': 'Panier',
    'shopping details': 'détail des achats',
    'Size': 'Taille',
    'Something went wrong during Yandex Checkout': 'Il y a eu un problème avec Yandex Checkout',
    'State/Region': 'Province',
    'Store selection': 'Sélection du magasin',
    'street': 'rue',
    'Street': 'Rue',
    'Street number': 'Numéro de rue',
    'Sunday': 'dimanche',
    'Surname': 'Nom',
    'Tax included': 'Toutes taxes comprises',
    'Telephone': 'Téléphone',
    'Telephone number': 'Numéro de téléphone',
    'Telephone number for courier / store pickup': 'Numéro de téléphone pour le service de messagerie / ramassage en magasin',
    'Terranova stores near you': 'Magasins Terranova près de chez vous',
    'The coupon code isn\'t valid. Verify the code and try again.': 'Le coupon n\'est pas valide.Vérifiez le code et réessayez.',
    'The gift card is invalid or empty. Please check the gift card and try again': 'La carte cadeau est invalide ou vide. Vérifiez la carte cadeau et réessayez',
    'The maximum value of the usable We+Card bonus is': 'La valeur maximale du bonus WE Card utilisable est',
    'The maximum value of the usable WE+Card points is': 'La valeur maximale des points de la carte WE utilisables est de',
    'The order is already been paid, please wait while order is placing': 'La commande a déjà été payée, attendez la confirmation de la commande',
    'The password must be made up of at least 8 characters, including a capital letter, a small letter, a number and a special character (.;,!$#).': 'Le mot de passe doit avoir au moins 8 caractères et contenir une majuscule, une minuscule, un chiffre et un caractère spécial (.;,!$#).',
    'The requested qty is not available': 'La quantité demandée n\'est pas disponible',
    'There has been an error. Please try again': 'Il y a eu une erreur. Réessayez',
    'This email already esists. Do the login or proceed as guest': 'Cet e-mail existe déjà. Connectez-vous ou continuez comme invité',
    'This product is not available, please remove it from cart to proceed': 'Ce produit n\'est pas disponible, veuillez le supprimer du panier pour continuer',
    'Thursday': 'jeudi',
    'To': 'À',
    'Total': 'Total',
    'Tuesday': 'mardi',
    'Type of card': 'Type de carte',
    'Update address': 'Mettre à jour l\'adresse',
    'Use Glam Card Bonus': 'Utiliser le Bonus WE Card',
    'Use points': 'Utiliser bonus',
    'Use WE+ points': 'Utiliser les points de la WE Card',
    'User': 'Utilisateur',
    'Valid until': 'expire le',
    'VAT number': 'Code fiscal',
    'Verify billing address': 'Vérifiez l’adresse de facturation',
    'Verify Gift Card': 'Vérifier la carte-cadeau',
    'Verify payment method selection': 'Vérifiez la méthode de paiement choisie',
    'Verify shipping address': 'Vérifiez l’adresse de livraison',
    'Verify shipping method selection': 'Vérifiez la méthode de livraison',
    'View your cart': 'Voir votre panie',
    'Wait for page to reload': 'Attendre la page pour recharger',
    'We\'re unable to send the password reset email': 'Impossible d\'envoyer l\'e-mail de réinitialisation du mot de passe. Contrôlez l\'e-mail saisi',
    'Wednesday': 'mercredi',
    'You are ordering with this email address': 'Vous êtes en train de passer une commande avec cette adresse e-mail',
    'You are shipping in a foreign country': 'Vous êtes en train d\'expédier à l\'étranger',
    'Your available points': 'Vos points disponibles',
    'Your avalaible bonus': 'Solde Bonus',
    'Zip code': 'C.P.',
    'Zip or city': 'Code postal ou ville',
    'zipdigitwarnings': 'Warning the zip code should consist of {zipdigits} charachters',
    'Shipping cost excluded': 'Hors frais d\'expédition',
    'Extra address': 'Informations complémentaires (facultatif)',
    'Extra address placeholder': 'c/o, porte, hameau, nom sur l\'interphone',
    '8 characters': '8 caractères',
    '1 lowercase letter': '1 lettre minuscule',
    '1 uppercase letter': '1 lettre majuscule',
    '1 number': '1 chiffre',
    '1 special character': '1 caractère spécial',
    'Now you can use your points': 'Vous pouvez maintenant utiliser vos points',
    'Hallo': 'Bonjour',
    'Save Credit Card (One Click Payment)': 'Enregistrer la carte de crédit (paiement en un clic)',
    'Pay with a saved credit card': 'Payer avec une carte de crédit enregistrée',
    'Pay with a new credit or debit card': 'Payer avec une nouvelle carte de crédit ou de débit',
    'Expiration': 'Expiration',
    'Other': 'Autre',
    'Applied discounts': 'Remises appliquées',
    'Choose size': 'Choisir la taille',
    'Municipality': 'Ville',
    'amount-for-freeshipping': 'Il vous manque {amount} pour bénéficier de la livraison gratuite par transporteur',
    'To proceed you must select a payment method': 'Pour continuer, vous devez sélectionner un moyen de paiement',
    'To proceed you need to save the selected billing address': 'Pour continuer, vous devez enregistrer l\'adresse de facturation sélectionnée',
    'To proceed it is necessary to accept the general conditions of sale': 'Pour continuer, vous devez accepter les conditions générales de vente',
    'To proceed you need to select the store': 'Pour continuer, vous devez sélectionner le magasin',
    'To proceed you need to save your changes': 'Pour continuer, vous devez enregistrer vos modifications',
    'Are you sure you want to delete this address?': 'Etes-vous sûr de vouloir supprimer cette adresse ?',
    'To proceed you need to save the selected shipping address': 'Pour continuer, vous devez enregistrer l\'adresse de livraison sélectionnée',
    'message-double_optin_using_point_disabled': 'Vous ne pouvez pas échanger de points pour cet achat car vous n\'avez pas encore confirmé la validité de votre adresse électronique ou de votre numéro de téléphone. Pour toute question, merci de contacter le service client.',
}

export default fr;
export const frValidation = {
    name: "fr",
    messages: {
        _default: function (e: any) {
            return "La valeur du champ " + e + " n'est pas valide."
        },
        after: function (e: any, n: any) {
            return "Le " + e + " doit être après " + n[0] + "."
        },
        alpha: function (e: any) {
            return "Le champ " + e + " ne peut contenir que des caractères alphabétiques."
        },
        alpha_dash: function (e: any) {
            return "Le champ " + e + " peut contenir des caractères alphanumériques ainsi que des traits d'union et des traits de soulignement."
        },
        alpha_num: function (e: any) {
            return "Le champ " + e + " ne peut contenir que des caractères alphanumériques."
        },
        alpha_spaces: function (e: any) {
            return "Le champ " + e + " ne peut contenir que des caractères alphanumériques et des espaces."
        },
        before: function (e: any, n: any) {
            return "Le champ " + e + " doit être avant " + n[0] + "."
        },
        between: function (e: any, n: any) {
            return "Le champ " + e + " doit être compris entre " + n[0] + " et " + n[1] + "."
        },
        confirmed: function (e: any, n: any) {
            return "Le champ " + e + " ne correspond pas à " + n[0] + "."
        },
        credit_card: function (e: any) {
            return "Le champ " + e + " n'est pas valide."
        },
        date_between: function (e: any, n: any) {
            return "Là " + e + " doit être comprise entre " + n[0] + " et " + n[1] + "."
        },
        date_format: function (e: any, n: any) {
            return "Là " + e + " doit être au format " + n[0] + "."
        },
        decimal: function (e: any, n: any) {
            void 0 === n && (n = []);
            var r = n[0];
            return void 0 === r && (r = "*"), "Le champ " + e + " doit être numérique et peut contenir" + (r && "*" !== r ? " " + r : "") + " des points décimaux."
        },
        digits: function (e: any, n: any) {
            return "Le champ " + e + " doit être numérique et contenir exactement " + n[0] + " des chiffres."
        },
        dimensions: function (e: any, n: any) {
            return "Le champ " + e + " doit être " + n[0] + " x " + n[1] + "."
        },
        email: function (e: any) {
            return "Le champ " + e + " doit être une adresse e-mail valide."
        },
        excluded: function (e: any) {
            return "Le champ " + e + " doit avoir une valeur valide."
        },
        ext: function (e: any) {
            return "Le champ " + e + " doit être un fichier valide."
        },
        image: function (e: any) {
            return "Le champ " + e + " doit être une image."
        },
        included: function (e: any) {
            return "Le champ " + e + " doit avoir une valeur valide."
        },
        ip: function (e: any) {
            return "Le champ " + e + " doit être une adresse IP valide."
        },
        length: function (e: any, n: any) {
            return "La longueur du champ " + e + " doit être " + n[0] + "."
        },
        max: function (e: any, n: any) {
            return "Le champ " + e + " ne peut pas être plus long que " + n[0] + " caractères."
        },
        max_value: function (e: any, n: any) {
            return "Le champ " + e + " doit être inférieur ou égal à " + n[0]
        },
        mimes: function (e: any) {
            return "Le champ " + e + " doit avoir un type de fichier valide."
        },
        min: function (e: any, n: any) {
            return "Le champ " + e + " doit avoir au moins " + n[0] + " caractères."
        },
        min_value: function (e: any, n: any) {
            return "Le champ " + e + " doit être supérieur ou égal à " + n[0]
        },
        numeric: function (e: any) {
            return "Le champ " + e + " ne peut contenir que des caractères numériques."
        },
        regex: function (e: any) {
            return "Le champ " + e + " n'a pas un format valide."
        },
        required: function (e: any) {
            return "Le champ " + e + " est nécessaire."
        },
        size: function (e: any, n: any) {
            return "Le champ " + e + " doit être inférieur à " + function (e) {
                const n = 1024;
                const r = 0 === (e = Number(e) * n) ? 0 : Math.floor(Math.log(e) / Math.log(n));
                const f = parseFloat((e / Math.pow(n, r)).toFixed(2));
                const v = 1 * f;
                return v.toFixed(2) + " " + ["Byte", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][r]
            }(n[0]) + "."
        },
        url: function (e: any) {
            return "Le champ " + e + " n'est pas une URL valide."
        },
        'validate-piva-cf': function (e: any) {
            return 'Numéro de TVA/code TVA non valide.';
        },
        'validate-regionid': function (e: any) {
            return 'Le champ Province est obligatoire.';
        },
        'validate-ascii': function(e: any) {
            return 'This field cannot contains special charachters';
        },
        'validate-streetandnumber': function(e: any, n: any) {
            return 'Street and street number fields must not exceed {2} charachters';
        },
        'validate-data-consensus': function(e: any) {
          return 'Votre consentement est requis pour le traitement des données personnelles.';
        },
        'validate-gender': function(e: any) {
            return 'Le champ Sexe est obligatoire.';
        },
        'validate-password': function(e: any) {
            return 'Le mot de passe doit avoir au moins 8 caractères et contenir une majuscule, une minuscule, un chiffre et un caractère spécial (.;,!$#).';
        },
    },
    attributes: {}
};
